import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetUserRequests = async () => {
  try {
    const RequestsCollection = collection(db, "Requests");

    const q = query(RequestsCollection, where("IsDeleted", "==", false));
    const RequestsSnapshot = await getDocs(q);

    let RequestsData = [];

    RequestsSnapshot.forEach((doc) => {
      RequestsData.push({ ...doc.data(), id: doc.id });
    });
    return RequestsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetUserRequests;
